const units = require('./src/units');
const geofences = require('./src/geofences');
const dst = require('./src/dst');
const co2Saved = require('./src/co2Saved');
const address = require('./src/address');
const hours = require('./src/hours');
const time = require('./src/time');
const ein = require('./src/ein');
const importDonationDate = require('./src/importDonationDate');
const subscriptions = require('./src/subscriptions');
const findDonationsFilters = require('./src/findDonationsFilters');
const brandTextUtils = require('./src/brandText');
const inventoryDonation = require('./src/inventoryDonation');
const displayDate = require('./src/displayDate');
const newsletterConsent = require('./src/newsletterConsent');

const acceptedFoodTypeFilterMinimumWeightLbs = 50;

module.exports = {
  DISPLAY_DATE_PRESETS: displayDate.DISPLAY_DATE_PRESETS,
  displayDatePattern: displayDate.displayDatePattern,
  formatDisplayDate: displayDate.formatDisplayDate,
  Weight: units.Weight,
  Distance: units.Distance,
  Temperature: units.Temperature,
  getLocaleUnit: units.getLocaleUnit,
  determineDefaultUnit: units.determineDefaultUnit,

  pointWithinAABB: geofences.pointWithinAABB,
  pointWithinPoly: geofences.pointWithinPoly,
  pointWithinPolys: geofences.pointWithinPolys,

  offsetForDST: dst.offsetForDST,
  constructUTCTimes: dst.constructUTCTimes,

  getImpact: co2Saved.getImpact,
  getTotalCO2Saved: co2Saved.getTotalCO2Saved,

  extractPlaceData: address.extractPlaceData,
  getStreetAddress: address.getStreetAddress,
  getValueFromAddressComponents: address.getValueFromAddressComponents,

  defaultHours: hours.defaultHours,
  transformHoursArrIntoObj: hours.transformHoursArrIntoObj,
  acceptedFoodTypeFilterMinimumWeightLbs,

  validateEndTimeAfterStartTime: time.validateEndTimeAfterStartTime,

  validateEIN: ein.validateEIN,
  getEINValidationMessage: ein.getEINValidationMessage,
  isUsEinCountry: ein.isUsEinCountry,

  subscriptions: subscriptions.subscriptions,
  getSubscriptionPriceId: subscriptions.getSubscriptionPriceId,
  getSubscriptionPriceIds: subscriptions.getSubscriptionPriceIds,
  getSubscriptionProductId: subscriptions.getSubscriptionProductId,
  getSubscriptionProductIds: subscriptions.getSubscriptionProductIds,
  getPlanBySubscriptionProductId: subscriptions.getPlanBySubscriptionProductId,
  getPlanProductIdSet: subscriptions.getPlanProductIdSet,
  getFoodMoverPriceIds: subscriptions.getFoodMoverPriceIds,
  getFoodMoverProductIds: subscriptions.getFoodMoverProductIds,
  getFoodRunProductIds: subscriptions.getFoodRunProductIds,
  getHomeDeliveryProductIds: subscriptions.getHomeDeliveryProductIds,
  getFoodMoverProProductIds: subscriptions.getFoodMoverProProductIds,
  NPO_SELF_SERVE_PLAN_KEYS: subscriptions.NPO_SELF_SERVE_PLAN_KEYS,
  NPO_ADMIN_PLAN_KEYS: subscriptions.NPO_ADMIN_PLAN_KEYS,
  NPO_ADDON_PLAN_KEYS: subscriptions.NPO_ADDON_PLAN_KEYS,
  PLAN_CAPABILITIES: subscriptions.PLAN_CAPABILITIES,
  getPlanCapabilities: subscriptions.getPlanCapabilities,
  hasPlanCapability: subscriptions.hasPlanCapability,
  plansWithCapability: subscriptions.plansWithCapability,
  isOpsPlan: subscriptions.isOpsPlan,
  isFoodMoverLitePlan: subscriptions.isFoodMoverLitePlan,
  HOME_DELIVERY_ADDON_ELIGIBLE_PLANS:
    subscriptions.HOME_DELIVERY_ADDON_ELIGIBLE_PLANS,
  HOME_DELIVERY_ADDON_PLAN_MAP: subscriptions.HOME_DELIVERY_ADDON_PLAN_MAP,
  HOME_DELIVERY_ADDON_BASE_PLAN_MAP:
    subscriptions.HOME_DELIVERY_ADDON_BASE_PLAN_MAP,
  getHomeDeliveryAddonTargetPlan: subscriptions.getHomeDeliveryAddonTargetPlan,
  getHomeDeliveryAddonBasePlan: subscriptions.getHomeDeliveryAddonBasePlan,
  canAddHomeDeliveryAddon: subscriptions.canAddHomeDeliveryAddon,
  isHomeDeliveryAddonPlan: subscriptions.isHomeDeliveryAddonPlan,
  normalizePlanKey: subscriptions.normalizePlanKey,
  hasEffectiveHomeDelivery: subscriptions.hasEffectiveHomeDelivery,
  getEffectivePlanCapabilities: subscriptions.getEffectivePlanCapabilities,
  HOME_DELIVERY_ADDON: subscriptions.HOME_DELIVERY_ADDON,
  getHomeDeliveryAddonProductId: subscriptions.getHomeDeliveryAddonProductId,
  getHomeDeliveryAddonPriceId: subscriptions.getHomeDeliveryAddonPriceId,
  getHomeDeliveryAddonProductIds: subscriptions.getHomeDeliveryAddonProductIds,
  getHomeDeliveryAddonPriceIds: subscriptions.getHomeDeliveryAddonPriceIds,
  isHomeDeliveryAddonPriceId: subscriptions.isHomeDeliveryAddonPriceId,
  isHomeDeliveryAddonProductId: subscriptions.isHomeDeliveryAddonProductId,
  parseStripeSubscriptionItems: subscriptions.parseStripeSubscriptionItems,
  PLAN_PRICING: subscriptions.PLAN_PRICING,
  HOME_DELIVERY_ADDON_PRICING: subscriptions.HOME_DELIVERY_ADDON_PRICING,
  WHITE_LABEL_PRICING: subscriptions.WHITE_LABEL_PRICING,
  getPlanPricing: subscriptions.getPlanPricing,
  formatMoney: subscriptions.formatMoney,
  formatPlanPriceSummary: subscriptions.formatPlanPriceSummary,

  IMPORT_DONATION_DATE_FORMAT_DISPLAY:
    importDonationDate.IMPORT_DONATION_DATE_FORMAT_DISPLAY,
  MIN_IMPORT_DONATION_YEAR: importDonationDate.MIN_IMPORT_DONATION_YEAR,
  MAX_IMPORT_DONATION_YEAR: importDonationDate.MAX_IMPORT_DONATION_YEAR,
  parseImportDonationDate: importDonationDate.parseImportDonationDate,

  FIND_DONATIONS_FILTER_SETTING_VERSION:
    findDonationsFilters.FIND_DONATIONS_FILTER_SETTING_VERSION,
  FIND_DONATIONS_FILTER_SETTING_PREFIX:
    findDonationsFilters.FIND_DONATIONS_FILTER_SETTING_PREFIX,
  getFindDonationsFilterSettingKey:
    findDonationsFilters.getFindDonationsFilterSettingKey,
  findDonationsTimeToMinutes: findDonationsFilters.findDonationsTimeToMinutes,
  normalizeFindDonationsFilters:
    findDonationsFilters.normalizeFindDonationsFilters,

  DEFAULT_BRAND_NAME: brandTextUtils.DEFAULT_BRAND_NAME,
  brandText: brandTextUtils.brandText,
  createBrandNamePostProcessor: brandTextUtils.createBrandNamePostProcessor,
  isNonBrandableKey: brandTextUtils.isNonBrandableKey,
  applyInventoryAnalysisQuantities:
    inventoryDonation.applyInventoryAnalysisQuantities,
  buildInventoryAnalysisItems: inventoryDonation.buildInventoryAnalysisItems,
  buildInventoryDonationPrefill:
    inventoryDonation.buildInventoryDonationPrefill,
  mergeInventoryDonationAnalysis:
    inventoryDonation.mergeInventoryDonationAnalysis,
  normalizeInventoryDonationFoodType:
    inventoryDonation.normalizeInventoryDonationFoodType,
  retainInventoryPhotosForDonation:
    inventoryDonation.retainInventoryPhotosForDonation,
  selectInventoryPhotosForDonation:
    inventoryDonation.selectInventoryPhotosForDonation,
  toDonationInventoryPayload: inventoryDonation.toDonationInventoryPayload,
  STOCK_PHOTO_PREFIX: inventoryDonation.STOCK_PHOTO_PREFIX,
  isStockPhotoKey: inventoryDonation.isStockPhotoKey,
  hasOnlyStockPhotos: inventoryDonation.hasOnlyStockPhotos,

  NEWSLETTER_CONSENT_VERSION: newsletterConsent.NEWSLETTER_CONSENT_VERSION,
  NEWSLETTER_CONSENT_TEXTS: newsletterConsent.NEWSLETTER_CONSENT_TEXTS,
  NEWSLETTER_CONSENT_VERSIONS: newsletterConsent.NEWSLETTER_CONSENT_VERSIONS,
  isNewsletterConsentVersion: newsletterConsent.isNewsletterConsentVersion,
};
